import { PointMeasurementDetails } from './PointMeasurementDetails';
import { PointMeasurementOptions } from './PointMeasurementOptions';
import { createPointMeasurementController } from './point-measurement-controller';

export const pointMeasurementConfig = {
  detailsComponent: PointMeasurementDetails,
  optionsComponent: PointMeasurementOptions,
  createController: createPointMeasurementController,
};

export type {
  PointDetailsProps,
  PointMeasurementController,
} from './point-measurement.types';
export type { PointMeasurementDetailsProps } from './PointMeasurementDetails';
export type { PointMeasurementOptionsProps } from './PointMeasurementOptions';
export {
  PointMeasurementDetails,
  PointMeasurementOptions,
  createPointMeasurementController,
};
